import { isShapeObjectType } from "@bezpart-board/shared";
import type { SceneObject } from "../SceneHost";

/**
 * Типы, у которых поворот хранится в поле `rotation`. У линий и росчерков
 * поворота нет — там поворачиваются сами точки.
 *
 * Лежит отдельным файлом, а не в rotate.ts, потому что нужен и в resize.ts:
 * rotate.ts тянет textObject.ts, а тот — обратно resize.ts, и импорт замкнул бы
 * модули в кольцо.
 */
export function usesRotationField(obj: SceneObject): boolean {
  return (
    isShapeObjectType(obj.type) ||
    obj.type === "text" ||
    obj.type === "sticky" ||
    obj.type === "image" ||
    obj.type === "rect"
  );
}
